export const header = {
  fontSize: "1.125em",
  color: "rgba(0,0,0,.87)",
  fontWeight: "bold",
};
